import WidgetForm from './WidgetForm';
export default WidgetForm;



// WEBPACK FOOTER //
// ./src/components/WidgetForm/index.js